import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { apiFetch } from './api-client';

type Feature = 'job_lunch' | 'estimate_email' | 'invoice_email' | 'deposit_balance_guard' | 'invoice_line_order' | 'photo_details' | 'equipment_details' | 'estimate_costs' | 'estimate_delete' | 'estimate_pdf' | 'card_deposits' | 'future_job_details';
const FieldWorkflowContext = createContext<ReadonlySet<Feature>>(new Set());

// Older APIs return 404. Keep their request contracts and hide unavailable actions.
export function FieldWorkflowProvider({children}: {children: ReactNode}) {
  const [features,setFeatures] = useState<ReadonlySet<Feature>>(new Set());
  useEffect(()=>{
    const controller=new AbortController();
    void apiFetch('/api/v1/workspace/field/capabilities',{signal:controller.signal}).then(async response=>{
      if(!response.ok)return;
      const body=await response.json();
      if(!controller.signal.aborted && Array.isArray(body.data?.features))setFeatures(new Set(body.data.features));
    }).catch(()=>undefined);
    return()=>controller.abort();
  },[]);
  return <FieldWorkflowContext.Provider value={features}>{children}</FieldWorkflowContext.Provider>;
}
export const useFieldWorkflow = () => useContext(FieldWorkflowContext);
